<template>
  <div>
    <v-layout
      row
      wrap
      justify-center
      class="mt-4"
    >
      <v-flex
        xs12
        sm10
        md10
        lg5
        xl5
        class="mt-4"
      >
        <v-card raised>
          <v-tabs
            v-model="activeTab"
            slider-color="blue"
            grow
          >
            <v-tab>
              Login
            </v-tab>
            <v-tab>
              Signup
            </v-tab>

            <!-- Login -->
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <form @submit.prevent="login()">
                    <div class="row">
                      <div class="col-sm-12">
                        <v-text-field
                          v-model="loginForm.phone_number"
                          label="Phone number"
                          :error-messages="errors.collect('Phone number')"
                          v-validate="'required'"
                          data-vv-name="Phone number"
                        >
                        </v-text-field>
                      </div>
                      <div class="col-sm-12">
                        <v-text-field
                          label="Password"
                          v-model="loginForm.password"
                          :append-icon="e1 ? 'visibility' : 'visibility_off'"
                          :append-icon-cb="() => (e1 = !e1)"
                          :type="e1 ? 'password' : 'text'"
                          :error-messages="errors.collect('Password')"
                          v-validate="'required'"
                          data-vv-name="Password"
                        >
                        </v-text-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <v-btn
                          type="submit"
                          style="height:auto; width:100%"
                          color="success"
                          depressed
                        >
                          Login <i class="fa fa-arrow-right ml-2" />
                        </v-btn>
                      </div>
                    </div>
                  </form>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Signup -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <!-- phone number input -->
                  <form
                    v-if="!showOtpInput"
                    @submit.prevent="signup()"
                  >
                    <div class="row">
                      <div
                        class="col-sm-1 mt-20 pt-1 text-right"
                        style="font-size: 1.5rem;"
                      >
                        +964
                      </div>
                      <div class="col-sm-11">
                        <v-text-field
                          v-model="signupForm.phone_number"
                          label="Phone number"
                          placeholder="7701234567"
                          :error-messages="errors.collect('Phone number')"
                          v-validate="'required'"
                          data-vv-name="Phone number"
                        >
                        </v-text-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <v-btn
                          type="submit"
                          style="height:auto; width:100%"
                          color="primary"
                          depressed
                        >
                          Next <i class="fa fa-arrow-right ml-2" />
                        </v-btn>
                      </div>
                    </div>
                  </form>

                  <!-- otp input -->
                  <form
                    v-if="showOtpInput"
                    @submit.prevent="verifyOtpCode()"
                  >
                    <div class="row">
                      <div class="col-sm-12">
                        <v-text-field
                          v-model="signupForm.otp_code"
                          label="Code"
                          :error-messages="errors.collect('Code')"
                          v-validate="'required'"
                          data-vv-name="Code"
                        >
                        </v-text-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <v-btn
                          type="submit"
                          style="height:auto; width:100%"
                          color="primary"
                          depressed
                        >
                          Next <i class="fa fa-arrow-right ml-2" />
                        </v-btn>
                      </div>
                    </div>
                  </form>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
  data() {
    return {
      activeTab: 0,
      e1: true,
      showOtpInput: false,
      loginForm: {
        phone_number: '+9647708948086',
        password: null
      },
      signupForm: {
        phone_number: '+9647708948086',
        otp_code: null
      }
    }
  },

  methods: {
    login() {
      // let token = localStorage.getItem('access_token')
      axios.post('api/mobile/login', this.loginForm).then(res => {
        this.$emit('logged-in', res.data.access_token)
        this.showOtpInput = true
      }).catch(error => {
        swal('Error', error.response.data.message, 'error')
      })
    },

    signup() {
      axios.post('api/verify-phone-number', this.signupForm).then(() => {
        this.showOtpInput = true
      })
    },

    verifyOtpCode() {
      axios.post('api/verify-otp-code', this.signupForm).then(() => {
        this.showOtpInput = false
        this.activeTab = 0
        swal('Done', '', 'success')
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/customerRegistration.vue